/* Webstra: Im Joy-Abo-Widget ist "Einmaliger Kauf" vorausgewählt.
   Greift nur, solange der Kunde selbst noch keine Option angeklickt hat. */
(() => {
  const ONE_TIME = /einmal/i;
  let userChose = false;
  let scheduled = false;

  document.addEventListener('click', (event) => {
    if (event.isTrusted && event.target.closest && event.target.closest('.Avada-Subscription__Radio-Item')) {
      userChose = true;
    }
  }, true);

  const apply = () => {
    scheduled = false;
    if (userChose) return;
    document.querySelectorAll('.Avada-Subscription__Radio-Item').forEach((item) => {
      const label = item.querySelector('.Avada-Subscription__Radio-Label');
      if (!label || !ONE_TIME.test(label.textContent)) return;
      if (item.classList.contains('--RadioActive')) return;
      item.click();
    });
  };

  const schedule = () => {
    if (scheduled || userChose) return;
    scheduled = true;
    window.requestAnimationFrame(apply);
  };

  const start = () => {
    apply();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
